import { z } from 'zod'

export const SADHANA_DURATION_SECONDS = 15 * 60

export const sadhanaMediaTypeSchema = z.enum(['audio', 'video'])
export const sadhanaMediaSourceSchema = z.enum(['upload', 'youtube', 'external'])

export const createSadhanaItemSchema = z.object({
  title_en: z.string().min(1).max(200),
  title_hi: z.string().min(1).max(200),
  description_en: z.string().min(1).max(5000),
  description_hi: z.string().min(1).max(5000),
  media_type: sadhanaMediaTypeSchema,
  media_source: sadhanaMediaSourceSchema,
  media_url: z.string().min(1),
  thumbnail_url: z.string().optional().nullable(),
  is_active: z.boolean().optional(),
})

export const updateSadhanaItemSchema = createSadhanaItemSchema.partial()

export const createSadhanaCompletionSchema = z.object({
  started_at: z.string().min(1),
})

export type CreateSadhanaItemInput = z.infer<typeof createSadhanaItemSchema>
export type UpdateSadhanaItemInput = z.infer<typeof updateSadhanaItemSchema>
export type CreateSadhanaCompletionInput = z.infer<
  typeof createSadhanaCompletionSchema
>

export type SadhanaItemResponse = {
  id: string
  title_en: string
  title_hi: string
  description_en: string
  description_hi: string
  media_type: 'audio' | 'video'
  media_source: 'upload' | 'youtube' | 'external'
  media_url: string
  thumbnail_url: string | null
  display_order: number
  is_active: boolean
  created_at: string
  updated_at: string
}

export type SadhanaCompletionResponse = {
  id: string
  sadhana_item_id: string
  started_at: string
  completed_at: string
  duration_seconds: number
}
